import styled from 'styled-components';

export const DropdownContainer = styled.div`
  position: relative;
  display: inline-block;
`;

export const DropdownButton = styled.button`
  background-color: var(--white);
  border: 1px solid var(--neutral-4);
  border-radius: 8px;
  padding: 8px 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: 180px;
  height: 40px;

  &:hover {
    border-color: var(--primary);
  }

  svg {
    margin-left: 8px;
  }
`;

export const DropdownContent = styled.div<{ isOpen: boolean }>`
  opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
  visibility: ${({ isOpen }) => (isOpen ? 'visible' : 'hidden')};
  transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;
  position: absolute;
  right: 0;
  top: calc(100% + 8px);
  background-color: var(--white);
  border-radius: 8px;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  width: 320px;
  max-height: 410px;
  z-index: 100;
  overflow: hidden;
`;

export const DropdownHeader = styled.div`
  padding: 16px 16px;
  border-bottom: 1px solid var(--neutral-4);
`;

export const DropdownTitle = styled.div`
  font-weight: 600;
  font-size: 16px;
  color: var(--neutral-10);
  margin-bottom: 4px;
`;

export const DropdownSubtitle = styled.div`
  font-size: 14px;
  color: var(--neutral-7);
`;

export const ItemsContainer = styled.div`
  overflow-y: auto;
  height: 260px;
`;

export const Item = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px solid var(--neutral-3);
  height: 64px;
  cursor: pointer;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: var(--neutral-2);
  }
`;

export const ItemInfo = styled.div`
  flex: 1;
  overflow: hidden;
`;

export const ItemTitle = styled.div`
  font-weight: 500;
  font-size: 14px;
  color: var(--neutral-10);
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0 16px;
`;

export const ItemSubtitle = styled.div`
  font-size: 12px;
  color: var(--neutral-7);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0 16px;
`;

export const CheckboxContainer = styled.div`
  flex-shrink: 0;
  margin: 0 16px;
`;

export const Checkbox = styled.input.attrs({ type: 'checkbox' })`
  width: 18px;
  height: 18px;
  cursor: pointer;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 16px;
  border-top: 1px solid var(--neutral-4);
  gap: 12px;
`;

export const CancelButton = styled.button`
  background-color: var(--white);
  border: 1px solid var(--neutral-4);
  border-radius: 8px;
  padding: 8px 16px;
  cursor: pointer;
  font-weight: 500;

  &:hover {
    background-color: var(--neutral-3);
  }
`;

export const SubmitButton = styled.button`
  background-color: var(--primary);
  color: var(--white);
  border: none;
  border-radius: 8px;
  padding: 8px 16px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;

    &:hover {
      opacity: 0.5;
      background-color: var(--primary);
    }
  }

  &:hover {
    background-color: #006fde;
  }
`;

export const LoadingIndicator = styled.div`
  text-align: center;
  padding: 12px 0;
  color: var(--neutral-7);
`;

export const SkeletonItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  border-bottom: 1px solid var(--neutral-3);
  height: 64px;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: var(--neutral-2);
  }
`;

export const SkeletonInfo = styled.div`
  flex: 1;
`;

export const SkeletonTitle = styled.div`
  height: 16px;
  width: 70%;
  background-color: var(--neutral-3);
  border-radius: 4px;
  margin-bottom: 8px;
  animation: pulse 1.5s infinite ease-in-out;

  @keyframes pulse {
    0% {
      opacity: 0.6;
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0.6;
    }
  }
`;

export const SkeletonSubtitle = styled.div`
  height: 12px;
  width: 50%;
  background-color: var(--neutral-3);
  border-radius: 4px;
  animation: pulse 1.5s infinite ease-in-out;
`;

export const SkeletonCheckbox = styled.div`
  width: 24px;
  height: 24px;
  background-color: var(--neutral-3);
  border-radius: 4px;
  margin-left: 16px;
  animation: pulse 1.5s infinite ease-in-out;
  flex-shrink: 0;
`;
